const FAILED_TO_FETCH = 'Failed to fetch';
const NETWORK_REQUEST_FAILED = 'Network request failed';
const REQUEST_TIMED_OUT = 'Network Error: Request timed out'; // for Node.js env but still including, just in case;

export const NETWORK_TIMEOUT_ERROR_MESSAGES = [
  NETWORK_REQUEST_FAILED,
  REQUEST_TIMED_OUT,
  FAILED_TO_FETCH,
];
